export default __webpack_public_path__ + "static/media/image-product-4.9962862e.jpg";